module.exports = __webpack_public_path__ + "static/media/equal-housing-lender.7c68f044.svg";